(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["position-clear-shopfront"] && !Shopify.designMode) return;
  try {
    
  function initPositionClear(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pc-reveal-enter');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08 });
    scope.querySelectorAll('[data-pc-reveal]').forEach((element) => {
      if (element.dataset.pcObserved) return;
      element.dataset.pcObserved = 'true';
      if (element.getBoundingClientRect().top > window.innerHeight) observer.observe(element);
    });
  }
  initPositionClear(document);
  document.addEventListener('shopify:section:load', (event) => initPositionClear(event.target));

  } catch(e) { console.error(e); }
})();
})();
